import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { TemplateServiceService } from '../service/template-service.service'
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_FORMATS,
} from '@angular/material-moment-adapter';
const moment = require('moment');

export const YEAR_FORMATS = {
  parse: {
    dateInput: 'YYYY',
  },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'YYYY',
    monthYearA11yLabel: 'YYYY',
  },
};


@Component({
  selector: 'app-view-template',
  templateUrl: './view-template.component.html',
  styleUrls: ['./view-template.component.css'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: YEAR_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
  ],
})

export class ViewTemplateComponent implements OnInit {

  @ViewChild('filterModalRef') filterModalRef!: ElementRef;

  templateValues: any[] = [];
  service_id: any;
  filter: any;
  visible_to: any[] = [];
  searchTerm: string = '';
  responseData: any[] = [];
  isValue: boolean = true;
  noData: boolean = false;
  insuranceBtn: boolean = false;
  count: any;
  entities: any[] = []; // List of entities for dropdown
  tempFilters: any = { entity: null, financialYear: null };
  filters: any = { entity: null, financialYear: null };
  entityFieldId: any;
  financialYearFieldId: any;

  constructor(private router: Router, private templateservice: TemplateServiceService, private route: ActivatedRoute) { }

  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      this.service_id = params['service_id'];
      this.filter = params['filter']

     

      const filterElement = document.getElementById(this.filter);
      if (filterElement) {
        filterElement.style.color = '#5f269e';
        filterElement.style.fontWeight = '600';
      }



      this.templateservice.getTemplate(this.service_id).subscribe((response: any) => {

        let res = response.data
        // for insurance tracker 
        const fields = res.fields;

        if (res.name == 'Insurance Tracker') {
          this.insuranceBtn = true;
        }
        else {
          this.insuranceBtn = false;
        }

        if (Array.isArray(fields)) {
          fields.forEach(field => {
            const visibleTo = field.visible_to;
            const isRequired = field.required
            if (visibleTo == 1) {
              this.visible_to.push({ id: field.id, title: field.title });

            }
            if (field.title.toLowerCase().includes('entity')) {
              this.entityFieldId = field.id;
            }
            if (field.title.toLowerCase().includes('financial year') || field.title.toLowerCase().includes('year')) {
              this.financialYearFieldId = field.id;
            }

          });
        }
        // Load entities
        this.loadEntities();

        // Nested API call
        this.templateservice.getTemplateValue(null, this.service_id, 'false', this.filter,null, null).subscribe((response: any) => {
          let status = response.status
          let data = response.data
          if (status == 200 && data.length > 0) {
            let res = response.data
            this.templateValues = res;
            this.count = response.count
            this.templateservice.updateCount(this.count);
            this.filterData();

          }
          else {
            this.isValue = false;
            this.noData = true;
            this.count = response.count

          }
        });
      });

    });

  }

  handleCardClick(event: MouseEvent, id: any) {
    const queryParams = { service_id: this.service_id, id: id, action: 'view', filter: this.filter, count: this.count };

    const urlTree = this.router.createUrlTree(['template', 'save_template'], { queryParams: queryParams });
    const url = this.router.serializeUrl(urlTree);
    window.open(url, '_blank');

  }

  handleEditButtonClick(event: MouseEvent, id: any) {

    event.stopPropagation();
    // get the name of the template also
    // const name = "Insurance_Tracker"
    const queryParams = { service_id: this.service_id, id: id, action: 'edit', filter: this.filter, count: this.count };

    const urlTree = this.router.createUrlTree(['template', 'save_template'], { queryParams: queryParams });
    const url = this.router.serializeUrl(urlTree);
    window.open(url, '_blank');

  }

  handleDeleteButtonClick(event: MouseEvent, id: any) {
    event.stopPropagation();
    const queryParams = { service_id: this.service_id, id: id, action: 'delete' };

    const urlTree = this.router.createUrlTree(['template', 'save_template'], { queryParams: queryParams });
    const url = this.router.serializeUrl(urlTree);
    window.open(url, '_blank');

  }

  navigate() {
    const url = `/template/save_template?service_id=${this.service_id}&action=new&filter=addNew`;
    // window.open(url, '_blank');
    window.open(url);

  }

  filterData() {
    let filtered = this.templateValues;

    // Apply search filter
    if (this.searchTerm.trim()) {
      const searchTermLowerCase = this.searchTerm.toLowerCase();
      filtered = filtered.filter(item => {
        return (
          String(item.id).toLowerCase().includes(searchTermLowerCase) ||
          String(item.values['6'] || '').toLowerCase().includes(searchTermLowerCase) ||
          String(item.values['5'] || '').toLowerCase().includes(searchTermLowerCase) ||
          String(item.values['1'] || '').toLowerCase().includes(searchTermLowerCase) ||
          String(item.values['2'] || '').toLowerCase().includes(searchTermLowerCase) ||
          String(item.values['7'] || '').toLowerCase().includes(searchTermLowerCase)


        );
      });
    }

    // Apply entity filter
    if (this.filters.entity && this.entityFieldId) {
      filtered = filtered.filter(item => item.values[this.entityFieldId] === this.filters.entity);
    }

    // Apply financial year filter
    if (this.filters.financialYear && this.financialYearFieldId) {
      const year = moment(this.filters.financialYear).year();
      filtered = filtered.filter(item => item.values[this.financialYearFieldId] && item.values[this.financialYearFieldId].includes(year.toString()));
    }

    this.responseData = filtered;
    this.responseData.sort((a, b) => b.id - a.id);
  }


  onSearchChange() {
    this.filterData();
  }

  // downloadFile(event: MouseEvent, id: any) {
  //   event.stopPropagation();
  //   this.templateservice.getTemplateValue(id, this.service_id,'true').subscribe((response: any) => {
  //     console.log('the response is ',response.urls)
  //   })
  //   }

  downloadFile(event: MouseEvent, id: any) {
    event.stopPropagation();
    this.templateservice.getTemplateValue(id, this.service_id, 'true', null, null, null).subscribe((response: any) => {

      let urls = response.urls;
      this.downloadAll(urls)
    });
  }

  downloadAll(urls:any) {
    urls.forEach((url:any) => {
      let iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = url;
      document.body.appendChild(iframe);


      iframe.onload = function () {
        // setTimeout(() => {x
        document.body.removeChild(iframe);

        // }, 1000);
      };
    });
  }


  loadEntities() {
    this.templateservice.getCompanies(this.service_id).subscribe((response: any) => {
      console.log(response);

      if (response?.data) {
        this.entities = response.data.map((item: string) => ({
          name: item.trim()
        }));
      } else {
        this.entities = [];
      }
    }, (err) => {
      console.error('Error fetching entities:', err);
      this.entities = [];
    });
  }

  onYearSelected(event: any, picker: any) {
    const selectedYear = moment().year(event.year());
    this.tempFilters.financialYear = selectedYear;
    picker.close();
  }
 
applyFilters() {

  // clear the existing cards that are present

  let entity = this.tempFilters?.entity ? this.tempFilters.entity : null;
  let financialYear = this.tempFilters?.financialYear 
    ? new Date(this.tempFilters.financialYear).getFullYear() 
    : null;

  this.templateservice.getTemplateValue(null, this.service_id, 'false', this.filter, entity, financialYear).subscribe((response: any) => {
    this.responseData = [];
    this.count = response.count

    if (response.status == 200 && response.data.length > 0) {
      let res = response.data;
      this.templateValues = res;
      this.count = response.count;
      this.templateservice.updateCount(this.count);
      // this.filterData();
      this.noData = false;
      this.isValue = true;
      this.responseData = res
    }
    else {
      this.isValue = false;
      this.noData = true;
      this.count = response.count;
      this.templateValues = [];
      this.responseData = [];

    }
    this.templateservice.updateLinkText(this.filter , this.count)

  });

  this.closeFilterModal();
}

  closeFilterModal() {
    if (this.filterModalRef?.nativeElement) {
      const modal = (window as any).bootstrap.Modal.getInstance(this.filterModalRef.nativeElement);
      if (modal) {
        modal.hide();
      }
    }
  }

  clearFilters() {
    this.filters = { entity: null, financialYear: null };
    this.tempFilters = { entity: null, financialYear: null };
    this.filterData();
  }


}

